import { useQuery } from '@tanstack/react-query';
import React, { createContext, useContext } from 'react';

import { get } from '@eika-infrastruktur/request';

import { REST_BASE_URL } from '@/react-query/common';

import { FraudRiskLevel, Session } from '@generated-types';

import { AppLoader } from './loader/Loader';

const getSession = async () => get<Session>(`${REST_BASE_URL}/session`);

const useSessionQuery = () => useQuery<Session>({ queryKey: ['session'], queryFn: getSession });

interface Props {
    children: React.ReactNode;
    showLoading?: boolean;
}

export const SessionContext = createContext<Session>({
    bank: undefined,
    channel: '',
    creditProfile: undefined,
    customerIdRedirectUrl: '',
    customerIdUrl: '',
    debitProfile: undefined,
    fraudRisk: FraudRiskLevel.LOW,
    mobileBank: false,
    highAssurance: false,
    toggles: {},
    user: undefined,
});

export const useSession = () => useContext(SessionContext);

export const SessionLoader = ({ children, showLoading = true }: Props) => {
    const sessionQuery = useSessionQuery();

    if (!sessionQuery.isSuccess && showLoading) {
        return <AppLoader title="Laster bruker..." />;
    }

    if (!sessionQuery.data || (!showLoading && !sessionQuery.isSuccess)) return null;

    return <SessionContext.Provider value={sessionQuery.data}>{children}</SessionContext.Provider>;
};
